module.exports = __webpack_public_path__ + "static/img/shareTitle.3858c897.png";